var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { checkPhoneAuth, getCountriesInfo, makeOptionListFromCountriesInfo, validateCode, validatePhoneNumberWithCountryCode, } from '../../../businessLogics';
import { useEffect, useState } from 'react';
import { CustomSelect } from '../../atoms/CustomSelect/CustomSelect';
import { neutralDay, additional, mBody1, scc } from '@teamsparta/design-system';
import Input from '../../atoms/Input';
import AlertText from '../../atoms/AlertText';
import { useAtom } from 'jotai';
import { phoneCodeAtom, readWriteModalHistoryAtom, Tasks } from '../../../stores';
import Form from '../../templates/Form';
import { FormRowDivider } from '../../templates/Form/Form';
import RequestBtn from '../../atoms/RequestBtn';
import { fetchIsSignedUpNumber, usePostPhoneAuth, usePostPhoneAuthConfirm } from '../../../businessLogics/apis';
import { useShowDeadline } from '../../../businessLogics/hooks';
import { ButtonWithoutStyle } from '../../../styles/_common.style';
var PhoneAuthenticationForm = function (_a) {
    var countryCode = _a.countryCode, setCountryCode = _a.setCountryCode, phoneNumber = _a.phoneNumber, setPhoneNumber = _a.setPhoneNumber, isAuthentic = _a.isAuthentic, setIsAuthentic = _a.setIsAuthentic, isSignup = _a.isSignup, label = _a.label, isCheckAlertNeeded = _a.isCheckAlertNeeded;
    var options = makeOptionListFromCountriesInfo(getCountriesInfo());
    var _b = useAtom(readWriteModalHistoryAtom), currentTask = _b[0], updateHistory = _b[1];
    var _c = useAtom(phoneCodeAtom), code = _c[0], setCode = _c[1];
    var _d = useState(false), showRequestBtn = _d[0], setShowRequestBtn = _d[1];
    var _e = useState(true), showCheckBtn = _e[0], setShowCheckBtn = _e[1];
    var _f = useState(false), isRequestSendable = _f[0], setIsRequestSendable = _f[1];
    var _g = useState(false), isCheckable = _g[0], setIsCheckable = _g[1];
    var _h = useState('인증 요청'), requestBtnText = _h[0], setRequestBtnText = _h[1];
    var _j = useState(null), alertText = _j[0], setAlertText = _j[1];
    var _k = useState(null), deadTime = _k[0], setDeadTime = _k[1];
    var _l = useState(true), showCountDown = _l[0], setShowCountDown = _l[1];
    useEffect(function () {
        if (phoneNumber.length > 0 && !showRequestBtn) {
            setShowRequestBtn(true);
        }
        else if (phoneNumber.length === 0 && showRequestBtn) {
            setShowRequestBtn(false);
        }
    }, [phoneNumber]);
    useEffect(function () {
        if (phoneNumber.length > 0) {
            var isSendable = validatePhoneNumberWithCountryCode(countryCode.key, phoneNumber);
            setIsRequestSendable(isSendable);
        }
        setIsAuthentic(false);
        setDeadTime(null);
    }, [countryCode, phoneNumber]);
    useEffect(function () {
        if (isRequestSendable) {
            setAlertText(null);
        }
    }, [isRequestSendable]);
    useEffect(function () {
        if (code.length > 0 && !showCheckBtn && deadTime) {
            setShowCheckBtn(true);
        }
        else if (code.length === 0 && showCheckBtn) {
            setShowCheckBtn(false);
        }
        setIsCheckable(validateCode(code));
    }, [code]);
    useEffect(function () {
        if (isAuthentic) {
            setShowRequestBtn(false);
        }
    }, [isAuthentic]);
    useShowDeadline(deadTime, setAlertText, showCountDown);
    var sendPhoneAuth = usePostPhoneAuth(setDeadTime, setShowCountDown, setRequestBtnText);
    var requestPhoneAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isExistNumberRes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetchIsSignedUpNumber(countryCode.key, phoneNumber)];
                case 1:
                    isExistNumberRes = _a.sent();
                    if (isExistNumberRes.ok) {
                        switch (currentTask) {
                            case Tasks.SIGNUP_EMAIL:
                            case Tasks.CHANGE_PHONE_NUMBER_ENTER_AND_AUTH:
                                if (isExistNumberRes.is_unique) {
                                    setAlertText(_jsx(_Fragment, {}));
                                    sendPhoneAuth.mutate({ countryCode: countryCode.key, phoneNumber: phoneNumber });
                                }
                                else {
                                    setAlertText(_jsx(_Fragment, { children: isExistNumberRes.message }));
                                }
                                return [2];
                            default:
                                if (!isExistNumberRes.is_unique) {
                                    setAlertText(_jsx(_Fragment, {}));
                                    sendPhoneAuth.mutate({ countryCode: countryCode.key, phoneNumber: phoneNumber });
                                }
                                else {
                                    setAlertText(_jsx(_Fragment, { children: isExistNumberRes.message }));
                                }
                                return [2];
                        }
                    }
                    return [2];
            }
        });
    }); };
    var putConfirmCode = usePostPhoneAuthConfirm(setIsAuthentic, setCode, setDeadTime, setAlertText, setShowCountDown);
    var confirmCode = function () {
        if (isCheckable && deadTime && deadTime >= new Date())
            putConfirmCode.mutate({ countryCode: countryCode.key, phoneNumber: phoneNumber, code: code });
    };
    var checkAlert = function () {
        if (!alertText) {
            checkPhoneAuth(isAuthentic, setAlertText);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Form, __assign({ label: label, checkAlert: isCheckAlertNeeded ? checkAlert : null }, { children: [_jsx(CustomSelect, { optionList: options, selectedObject: countryCode, setSelectedObject: setCountryCode, isDisabled: false }), _jsx(FormRowDivider, {}), _jsxs(RowContainer, { children: [_jsx(Input, { value: phoneNumber, setValue: setPhoneNumber, placeHolder: (currentTask === Tasks.CHANGE_PHONE_NUMBER_ENTER_AND_AUTH ? '변경할 ' : '') + '휴대폰 번호 입력 (- 제외)', type: 'number', isEmbedded: true, maxLength: 14 }), _jsx(RequestBtn, { isShow: showRequestBtn, isActive: isRequestSendable, requestFunction: requestPhoneAuth, btnText: requestBtnText })] }), _jsx(FormRowDivider, { isHidden: isAuthentic }), _jsxs(RowContainer, __assign({ isHidden: isAuthentic }, { children: [_jsx(Input, { value: code, setValue: setCode, placeHolder: '인증번호 입력', isEmbedded: true, type: 'number', maxLength: 4 }), showCheckBtn && (_jsx(CheckBtn, __assign({ isActive: isCheckable, onClick: confirmCode }, { children: "\uD655\uC778" })))] }))] })), _jsx(AlertText, __assign({ isShow: !!alertText, color: deadTime ? neutralDay.gray70 : scc.red100, spanColor: scc.red100 }, { children: alertText })), _jsx(AlertText, __assign({ isShow: isAuthentic, color: additional.green100 }, { children: "\uC778\uC99D\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4." }))] }));
};
export default PhoneAuthenticationForm;
var RowContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: fit-content;\n  justify-content: space-between;\n  display: ", ";\n"], ["\n  width: 100%;\n  height: fit-content;\n  justify-content: space-between;\n  display: ", ";\n"])), function (_a) {
    var isHidden = _a.isHidden;
    return (isHidden ? 'none' : 'flex');
});
var CheckBtn = styled(ButtonWithoutStyle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 6px 16px;\n  margin: auto;\n  flex-shrink: 0;\n  ", ";\n  color: ", ";\n  cursor: ", ";\n"], ["\n  padding: 6px 16px;\n  margin: auto;\n  flex-shrink: 0;\n  ", ";\n  color: ", ";\n  cursor: ", ";\n"])), mBody1, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? neutralDay.gray100 : '#1416174d');
}, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? 'pointer' : 'default');
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=PhoneAuthenticationForm.js.map